import React, {useEffect, useState} from "react";
import {Box, Button, Grid, Link, TextField} from "@mui/material";
import {useTheme} from '@mui/material/styles';
import {Navigate} from "react-router";
import {login} from "./auth.slice";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import LoginContainer from "../../app/components/LoginContainer";

export default function Login() {
    const theme = useTheme();

    const [attempted, setAttempted] = useState(false);
    const dispatch = useAppDispatch();
    const authState = useAppSelector((state) => state.auth);

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        const loginData = {
            email: (data.get('email') || '').toString(),
            password: (data.get('password') || '').toString(),
        };
        dispatch(login({username: loginData.email, password: loginData.password})).then(() => {
            setAttempted(true)
        })
    };

    useEffect(() => {
        if (attempted && !authState.isLoggedIn) {
            const swal = withReactContent(Swal)
            swal.fire({
                title: 'Ops...',
                text: 'Login ou senha inválidos',
                icon: 'error',
                confirmButtonText: 'Ok',
            });
            setAttempted(false)
        }
    }, [attempted])

    if (authState.isLoggedIn) {
        return <Navigate to="/dashboard"/>;
    }

    return (
        <LoginContainer>
            <Box component="form" onSubmit={handleSubmit} noValidate sx={{mt: 1}}>
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    label="Email"
                    name="email"
                    autoComplete="email"
                    autoFocus
                />
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    label="Password"
                    type="password"
                    id="password"
                    autoComplete="current-password"
                />
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color='primary'
                    sx={{mt: 3, mb: 2, fontWeight:900, color: theme.palette.secondary.main}}
                >
                    Entrar
                </Button>
                <Grid container>
                    <Grid item xs>
                        <Link href="/password-recovery" variant="body2">
                            Esqueceu a senha?
                        </Link>
                    </Grid>
                    {/*<Grid item>*/}
                    {/*    <Link href="#" variant="body2">*/}
                    {/*        {"Não tem uma conta? Cadastre-se."}*/}
                    {/*    </Link>*/}
                    {/*</Grid>*/}
                </Grid>
            </Box>
        </LoginContainer>
    );
}
